import whatInput from 'what-input';
import lazySizes from 'lazysizes';
import Cookies from 'js-cookie';

lazySizes.cfg.expand = 300;
lazySizes.cfg.loadHidden = false;

(function ($) {
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Variables
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  var w = window,
    d = document,
    $window = $(w),
    html = d.documentElement,
    $html = $('html'),
    body = d.body,
    $body = $('body'),
    $header = $('#header'),
    $header_wrapper = $header.find('.header_wrapper'),
    $main = $('#main'),
    windowH,
    windowW,
    headerH,
    pageHeaderH,
    scrollT,
    scrollUp = false,
    $adminBar = $('#wpadminbar'),
    has_adminBar = $body.hasClass('admin-bar'),
    adminBar_h = 0,
    is_menu_mobile = false,
    is_acc_mobile = false,
    $triggerMobile = $('#menuTrigger'),
    $triggerMobile2 = $('#menuTrigger2'),
    sauvScroll = 0,
    alertBannerHeight,
    vhCssVar = false;


  $html.addClass('is-js-init');
  $main.find('.page_content').attr('id', 'content');

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Global events manager (events delegation)
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  var globalEvents = [];

  function setEvents(selector, callback) {
    globalEvents.push({
      'selector': selector,
      'callback': callback
    });
  }

  // if document the right click event is triggered
  body.addEventListener('click', function (event) {
    if (event.ctrlKey) return;

    globalEvents.forEach(function (ev) {
      if (event.target && event.target.matches(ev.selector + ', ' + ev.selector + ' *')) {
        event.stopPropagation();
        ev.callback(event, event.target.closest(ev.selector));
      }
    });
  }, false);

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Dimensions
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  function update_dimensions() {
    windowH = window.innerHeight;
    windowW = $window.width();
    headerH = $header.find('.header_wrapper').outerHeight();
    document.documentElement.style.setProperty('--header-h', headerH + 'px');
    pageHeaderH = $('.page_header').outerHeight() || window.innerHeight;
    var old_is_menu_mobile = is_menu_mobile;
    is_menu_mobile = $triggerMobile.is(':visible');
    if (old_is_menu_mobile != is_menu_mobile) {
      menu_mobile_change(old_is_menu_mobile, is_menu_mobile);
    }
    update_adminbar();
    update_scroll();
  }
  update_dimensions();

  function update_scroll() {
    if ($window.scrollTop() < scrollT) {
      scrollUp = true;
    } else {
      scrollUp = false;
    }
    scrollT = $window.scrollTop();
  }

  function update_adminbar() {
    adminBar_h = parseInt($html.css("margin-top")) + parseInt($body.css("margin-top"));
  }

  function menu_mobile_change(o, n) {
    remove_focus_trap_aria_hidden();
    if (!o && n) {
      accs_build();
    } else if (o && !n) {
      accs_mobile_reset();
    }
  }

  function setCssVarVH() {
    if (!vhCssVar || Math.abs(vhCssVar - windowH) > 250) {
      vhCssVar = windowH;
      document.documentElement.style.setProperty('--vh', windowH + 'px');
    }
  }

  function set_is_acc_mobile() {
    var old_is_acc_mobile = is_acc_mobile;
    is_acc_mobile = false;
    var $accMobile = $main.find('.js-acc-mobile');
    if ($accMobile.length) {
      var styles = window.getComputedStyle($accMobile.get(0), ":after");
      var contentValue = styles.content;
      contentValue = contentValue ? contentValue.replace(/['"]+/g, '') : '';
      is_acc_mobile = contentValue === 'acc';
    }
    if (old_is_acc_mobile != is_acc_mobile) {
      acc_mobile_change(old_is_acc_mobile, is_acc_mobile);
    }
  }

  function acc_mobile_change(o, n) {
    if (!o && n) {
      accs_build();
    } else if (o && !n) {
      accs_mobile_reset();
    }
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Helper functions
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  // Récupère les variables d'une url
  function getQueryVariables(url) {
    var query = url.split("?");
    var vars = (query.length > 1 ? query[1] : '').split("&");
    var returnVars = {};
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      returnVars[pair[0]] = pair[1] ? pair[1] : null;
    }
    return returnVars;
  }

  //Debounce
  function debounce(func, wait, immediate) {
    var timeout;
    return function () {
      var context = this, args = arguments;
      var later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  };

  //Load js async
  function async(script, callback) {
    var s = document.createElement('script'),
      head = document.getElementsByTagName('head')[0];
    s.type = "text/javascript";
    s.async = true;
    s.defer = true;
    s.src = script;
    if (typeof callback == 'function') { s.addEventListener('load', function (e) { callback.call(); }, false); }
    head.appendChild(s);
  }

  //Load css
  function loadCSS(href, callback, media) {
    var doc = w.document;
    var ss = doc.createElement("link");
    var ref;
    var refs = (doc.body || doc.getElementsByTagName("head")[0]).childNodes;
    ref = refs[refs.length - 1];
    var sheets = doc.styleSheets;
    ss.rel = "stylesheet";
    ss.href = href;
    ss.media = "only x";
    ref.parentNode.insertBefore(ss, ref.nextSibling);
    var onloadcssdefined = function (cb) {
      var resolvedHref = ss.href;
      var i = sheets.length;
      while (i--) {
        if (sheets[i].href === resolvedHref) {
          return cb();
        }
      }
      setTimeout(function () {
        onloadcssdefined(cb);
      });
    };
    function loadCB() {
      if (ss.addEventListener) {
        ss.removeEventListener("load", loadCB);
      }
      ss.media = media || "all";
      if (typeof callback == 'function') {
        callback();
      }
    }
    if (ss.addEventListener) {
      ss.addEventListener("load", loadCB);
    }
    ss.onloadcssdefined = onloadcssdefined;
    onloadcssdefined(loadCB);
  }

  //pad number
  function pad(number) {
    if (number < 10) {
      return '0' + number;
    }
    return number;
  }

  //resize select
  function resizeselect($cont) {
    $cont = $cont && $cont.length ? $cont : $main;
    $cont.find('select.resizeselect').each(function (idx, el) {
      let $this = $(el);
      let val = $this.val();
      let $test = $this.clone().removeAttr('style').removeClass('resizeselect');
      $test.find('option:not([value="' + val + '"])').remove();
      $test.appendTo($this.parent());
      let width = $test.outerWidth();
      $test.remove();
      $this.outerWidth(width);
    });
  }
  resizeselect();

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Scroll jusqu'a un element
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  function scrollToEl($el, marge) {
    var offsetEl = 0;
    if (marge) {
      offsetEl -= marge;
    }
    if ($el.length) {
      offsetEl += $el.offset().top - adminBar_h;
      // offsetEl += 2;
      var elMargin = parseInt($el.css('marginTop'));
      var elPadding = parseInt($el.css('paddingTop'));
      if (!elPadding && elMargin) {
        offsetEl -= elMargin;
      } else if (!elPadding) {
        elMargin = parseInt($el.prev().css('marginBottom'));
        elPadding = parseInt($el.prev().css('paddingBottom'));
        if (elPadding) {
          offsetEl -= elPadding;
        } else if (elMargin) {
          offsetEl -= elMargin;
        }
      }
    }
    // Menu masqué qui va slide down
    if (offsetEl < scrollT) {
      offsetEl -= $header.outerHeight();
    }
    scrollToOffset(offsetEl);
  }

  function scrollToOffset(offsetEl) {
    $('html, body').animate({
      scrollTop: offsetEl
    }, 1000);
  }

  function scroller_init($cont) {
    $cont = $cont && $cont.length ? $cont : $body;
    // var $directElToScroll = $cont.find('.js-scroll-to-me').first();
    // if ($directElToScroll.length) scrollToEl($directElToScroll);

    $cont.find('a.js-scroller[href^="#"]').on('click', function (event) {
      if (whatInput.ask() === 'keyboard') return;
      var $this = $(this);
      var $target = $($this.attr('href'));
      if ($target.length && $this.attr('data-scroll-parent')) {
        $target = $target.closest($this.attr('data-scroll-parent'));
      }
      if ($target.length) {
        event.preventDefault();
        scrollToEl($target);
      }
    });
  }
  scroller_init();

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Focus trap
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  var $lastFocusedElement = false;
  var is_focus_traped = false;

  function set_focus_trap($cont) {
    if (!$cont || !$cont.length) return;
    $lastFocusedElement = $(document.activeElement);
    update_content_focus_trap($cont);
    set_focus_trap_aria_hidden($cont);
    is_focus_traped = true;
  }

  function update_content_focus_trap($cont) {
    if (!$cont || !$cont.length) return;
    var $focusableElements = $cont.find('a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled])').not('[tabindex="-1"]');
    var $firstTabStop = $focusableElements.first();
    var $lastTabStop = $focusableElements.last();
    $firstTabStop.focus();
    $cont.off('keydown').on('keydown', function (event) {
      if (event.keyCode === 9) { //Tab
        if (event.shiftKey) { //Shift + Tab
          if (document.activeElement === $firstTabStop.get(0)) {
            event.preventDefault();
            $lastTabStop.focus();
          }
        } else { //just Tab
          if (document.activeElement === $lastTabStop.get(0)) {
            event.preventDefault();
            $firstTabStop.focus();
          }
        }
      }
    });
  }

  function remove_focus_trap($cont) {
    if (!$cont || !$cont.length) return;
    $cont.off('keydown');
    remove_focus_trap_aria_hidden();
    if ($lastFocusedElement && $lastFocusedElement.length) {
      $lastFocusedElement.focus();
    }
    is_focus_traped = false;
  }

  function set_focus_trap_aria_hidden($el) {
    $el.siblings(':not(script):not(link):not([aria-hidden])').attr('aria-hidden', 'true').addClass('is-hidden-by-focus-trap');
    // if($el.is('.nav')) {
    //   $el.closest('.header').siblings(':not(script):not(link):not([aria-hidden])').not('.toolbar').attr('aria-hidden', 'true').addClass('is-hidden-by-focus-trap');
    //   $('#toolbar').find('.toolbar_navi:not(.toolbar_navi-navmobile)').attr('aria-hidden', 'true').addClass('is-hidden-by-focus-trap');
    // }
  }

  function remove_focus_trap_aria_hidden() {
    $body.find('.is-hidden-by-focus-trap').removeAttr('aria-hidden').removeClass('is-hidden-by-focus-trap');
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Menu
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■

  var $navs_items = $('.nav_i-sub');
  var $btn = $header.find('.btn');
  $navs_items.find('> a:not(.btn)').on('click', function (e) {
    e.preventDefault();
    let $nav_item = $(this).parent();
    $nav_item.toggleClass('open');
    if ($btn.hasClass('is-style-color-white')) {
      if ($nav_item.hasClass("open")) {
        $html.addClass("has-subnavOpen");
        $btn.addClass('is-style-color-black');
        $btn.removeClass('is-style-color-white');
      } else {
        $html.removeClass("has-subnavOpen");
        $btn.removeClass('is-style-color-black');
        $btn.addClass('is-style-color-white');
      }
    } else {
      if ($nav_item.hasClass("open")) {
        $html.addClass("has-subnavOpen");
      } else {
        $html.removeClass("has-subnavOpen");
      }
    }

    $nav_item.find('.sub_menu').slideToggle({
      duration: 250,
      start: function () {
        var $sub_menu = $(this),
          $nav_item = $sub_menu.closest('.nav_i');
        if ($nav_item.hasClass('nav_i-search') && $nav_item.hasClass('open')) {
          $nav_item.find('input').trigger('focus');
        }
      }
    });
    $navs_items.filter('.open').not($nav_item).find('.sub_menu').hide();
    $navs_items.filter('.open').not($nav_item).removeClass('open');

    return false;
  });

  function menu_close() {
    $navs_items.removeClass('open');
    $navs_items.find('.sub_menu').slideUp(250);
    $html.removeClass('has-subnavOpen');
  }

  $window.on('hashchange', function () {
    if ($html.hasClass('has-filtersOpen')) {
      menu_close();
    }
  });

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Menu mobile
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  var idMenuMobileTimeOut = false;
  $triggerMobile.on('click', function (e) {
    e.preventDefault();
    menu_mobile_open();
  });
  $triggerMobile2.on('click', function (e) {
    e.preventDefault();
    menu_mobile_close();
  });

  // function menu_mobile_toggle() {
  //   if ($html.hasClass('has-menuMobileOpen')) {
  //     menu_mobile_close();
  //   } else {
  //     menu_mobile_open();
  //   }
  // }

  function menu_mobile_open() {
    if (!$html.hasClass('is-scrollBlockedMobile')) {
      sauvScroll = scrollT;
      idMenuMobileTimeOut = w.setTimeout(function () {
        w.scrollTo(0, 0);
        $html.addClass('is-scrollBlockedMobile');
      }, 500);
    }
    $html.addClass('has-menuMobileOpen');
  }

  function menu_mobile_close() {
    if (idMenuMobileTimeOut) w.clearTimeout(idMenuMobileTimeOut);
    $html.removeClass('is-scrollBlockedMobile');
    // closeSubMenu();
    w.scrollTo(0, sauvScroll);
    w.setTimeout(function () {
      $html.removeClass('is-nav-hide');
    }, 5);
    w.setTimeout(function () {
      $html.removeClass('has-menuMobileOpen');
    }, 50);
    w.setTimeout(function () {
      if ($html.hasClass('is-scrolled')) {
        $html.addClass('is-nav-hide');
      }
    }, 500);
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Filtres mobile
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  var idMenuTimeOut = false;
  var $menu = $main.find('.filters_selects');
  var $filterTriggerOpen = $("#filterTriggerOpen");
  var $filterTriggerClose = $("#filterTriggerClose");
  $filterTriggerOpen.on('click', function (event) {
    event.preventDefault();
    filter_open();
  });
  $filterTriggerClose.on('click', function (event) {
    filter_close();
  });

  // function menu_toggle() {
  //   if ($html.hasClass('has-filtersOpen')) {
  //     menu_close();
  //   } else {
  //     menu_open();
  //   }
  // }

  function filter_open() {
    $html.addClass('has-filtersOpen');
    if (!$html.hasClass('is-scrollBlockedMobile')) {
      sauvScroll = scrollT;
      idMenuTimeOut = w.setTimeout(function () {
        w.scrollTo(0, 0);
        $html.addClass('is-scrollBlockedMobile');
      }, 300);
    }
    set_focus_trap($menu);
  }

  function filter_close() {
    if (idMenuTimeOut) w.clearTimeout(idMenuTimeOut);
    $html.removeClass('is-scrollBlockedMobile');
    // closeSubMenu();
    w.scrollTo(0, sauvScroll);
    w.setTimeout(function () {
      // closeSubMenu(false);
      $html.removeClass('has-filtersOpen');
      remove_focus_trap($menu);
    }, 50);
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Accordéons
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  function accs_init($cont) {
    $cont = $cont && $cont.length ? $cont : $main;
    $cont.find('.acc:not(.js-acc)').addClass('js-acc');
    // $cont
    //   .find('.matiere_section:not(.js-acc)')
    //   .addClass('js-acc')
    //   .addClass('js-acc-mobile');
    accs_build($cont);
  }
  accs_init();

  function accs_build($cont) {
    $cont = $cont && $cont.length ? $cont : $main;
    $cont.find('.js-acc:not(.is-init)').each(function (idx, el) {
      acc_build(el);
    });
  }

  function acc_build(el, idAcc) {
    var $wrapper = $(el);
    var $head = $wrapper.children(':nth-last-child(2)');
    var $cont = $wrapper.children(':nth-child(2)');
    idAcc =
      idAcc ||
      Math.floor(Math.random() * (1000 + 1)) +
      1000 +
      '' +
      (Math.floor(Math.random() * (1000 + 1)) + 1000) +
      '' +
      (Math.floor(Math.random() * (1000 + 1)) + 1000) +
      '';
    if (
      !$head.length ||
      !$cont.length ||
      (!is_acc_mobile && $wrapper.hasClass('js-acc-mobile'))
    )
      return;
    $head
      .addClass('js-acc-head')
      .wrapInner(
        '<button type="button" aria-expanded="false" aria-controls="acc-id-' +
        idAcc +
        '" id="acc-title-id-' +
        idAcc +
        '"></button>'
      );
    $wrapper.addClass('is-init').addClass('is-closed');
    $cont
      .addClass('js-acc-content')
      .hide()
      .attr('id', 'acc-id-' + idAcc)
      .attr('aria-labelledby', 'acc-title-id-' + idAcc)
      .attr('aria-hidden', 'true');
    $head.on('click', 'button', function (event) {
      event.preventDefault();
      $cont.slideToggle(400);
      if ($wrapper.hasClass('is-closed')) {
        $wrapper.removeClass('is-closed');
        $head.find('[aria-expanded]').attr('aria-expanded', 'true');
        $cont.attr('aria-hidden', 'false');
        // $cont.find("select.resizeselect").resizeselect();
        $window.trigger('resize');
      } else {
        $wrapper.addClass('is-closed');
        $head.find('[aria-expanded]').attr('aria-expanded', 'false');
        $cont.attr('aria-hidden', 'true');
      }
    });
  }

  function accs_mobile_reset($cont) {
    $cont = $cont && $cont.length ? $cont : $main;
    if (is_acc_mobile) return;
    $cont.find('.js-acc-mobile.is-init').each(function (idx, el) {
      acc_reset(el);
    });
  }

  function acc_reset(el) {
    var $wrapper = $(el);
    var $head = $wrapper.children(':nth-last-child(2)');
    var $cont = $wrapper.children(':nth-child(2)');
    $wrapper.removeClass('is-init').removeClass('is-closed');
    $head
      .removeClass('js-acc-head')
      .off('click', 'button')
      .find('button')
      .contents()
      .unwrap();
    $cont
      .removeClass('js-acc-content')
      .removeAttr('id')
      .removeAttr('style')
      .removeAttr('aria-labelledby')
      .removeAttr('aria-hidden');
    // $cont.find("select.resizeselect").resizeselect();
    $window.trigger('resize');
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Scroll et ouverture accordéon initial
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  if (location.hash) {
    var locationHash = location.hash.replace('#', '');
    var $scrollTarget = $main.find('[data-target-id="' + locationHash + '"]');
    if (!$('#' + locationHash).length && $scrollTarget.length) {
      scrollToEl($scrollTarget);
      if ($scrollTarget.is('.js-acc.is-init.is-closed')) {
        $scrollTarget.find('.js-acc-head button').trigger('click');
      }
    }
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Alerte
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  function heightAlertBanner() {
    const alertBanner = $('.alertBanner');
    const alertHide = Cookies.get('angouleme-hide-alert');
    if (alertBanner.length === 0) { return; }

    alertBannerHeight = alertBanner[0].offsetHeight;

    if (alertHide != alertBanner.attr('id')) {
      $body.addClass('showAlertBanner');
      $main.css('margin-top', alertBannerHeight + 'px');
      // $header.css('top', adminBar_h);
      alertBanner.css('display', 'block');
    } else {
      $main.css('margin-top', 0 + 'px');
      // $header.css('top', '-' + (alertBannerHeight - adminBar_h) + 'px');
      alertBanner.css('display', 'none');
    }
  };

  const alertBanner = $('.alertBanner');
  $body.on('click', '.js-alert-close', function (event) {
    event.preventDefault();
    Cookies.set('angouleme-hide-alert', $(this).closest('.alertBanner').attr('id'), { expires: 3 });
    $main.css('margin-top', 0 + 'px');
    // $header.css('top', '-' + (alertBannerHeight - adminBar_h) + 'px');
    alertBanner.css('display', 'none');
    $body.removeClass('showAlertBanner');
  });

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Header (menu ou filtres)
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  function update_header() {
    update_adminbar();
    const alertBanner = $('.alertBanner');
    let alertBannerHeight;
    if (alertBanner.length !== 0) {
      alertBannerHeight = alertBanner.get(0).getBoundingClientRect().bottom
    } else {
      alertBannerHeight = 0
    }
  }
  update_header();

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Menu qui se masque
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  function auto_hide_header() {
    var $header_content = $main.find(".pHeader");
    // if(is_menu_mobile) {
    //   return;
    // }
    if (!scrollUp && scrollT > pageHeaderH) {
      $html.addClass('is-nav-hide');
    } else {
      $html.removeClass('is-nav-hide');
    }
    if (scrollT > pageHeaderH) {
      if (!$html.hasClass('is-scrolled')) {
        $html.addClass('is-no-transition');
        requestAnimationFrame(() => requestAnimationFrame(() => $html.removeClass('is-no-transition')));
      }
      $html.addClass('is-scrolled');
    } else {
      if ($html.hasClass('is-scrolled')) {
        $html.addClass('is-no-transition');
        requestAnimationFrame(() => requestAnimationFrame(() => $html.removeClass('is-no-transition')));
      }
      $html.removeClass('is-scrolled');
    }
    // if ($html.hasClass('is-nav-hide')) {
    //   $main.css('margin-top', 0 + 'px');
    // } else {
    heightAlertBanner();
    // }
    var $btn = $header.find('.btn');

    if ($header.hasClass('header_home') && $btn) {
      if (scrollT > pageHeaderH) {
        $header.removeClass('transparent_header');
        $btn.removeClass('is-style-color-white');
        $btn.addClass('is-style-color-black');
      } else if (scrollT <= pageHeaderH && !$html.hasClass("has-menuMobileOpen")) {
        $header.addClass('transparent_header');
        $btn.addClass('is-style-color-white');
        $btn.removeClass('is-style-color-black');
      }
    }
  }
  auto_hide_header();

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Plyr
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  var plyr_is_ready = false;
  var plyr_js_is_ready = false;
  var plyr_css_is_ready = false;
  var plyr_js_is_loading = false;
  var plyr_css_is_loading = false;
  var $videosIframes = [];
  $main.find('.media.is-type-video iframe[src]').wrap('<div class="js-plyr"></div>');
  $main.find('.media-audio audio[src]').addClass('js-plyr');

  function init_videos() {
    if (!$videosIframes.length) return;
    video_load_plyr();
  }

  function reinit_videos() {
    $videosIframes = $main.find('.js-plyr');
    init_videos();
  }
  reinit_videos();

  function video_load_plyr() {
    if (plyr_is_ready) {
      init_plyr_on_video();
      return;
    }

    if (!plyr_js_is_loading) {
      plyr_js_is_loading = true;
      async(url.theme + 'lib/plyr.min.js', plyr_js_loaded);
    }
    if (!plyr_css_is_loading) {
      plyr_css_is_loading = true;
      loadCSS(url.theme + 'lib/plyr.min.css', plyr_css_loaded);
    }
  }

  function plyr_js_loaded() {
    plyr_js_is_ready = true;
    check_plyr_is_ready();
  }

  function plyr_css_loaded() {
    plyr_css_is_ready = true;
    check_plyr_is_ready();
  }

  function check_plyr_is_ready() {
    if (!plyr_is_ready && plyr_js_is_ready && plyr_css_is_ready) {
      plyr_is_ready = true;
      init_plyr_on_video();
    }
    return plyr_is_ready;
  }

  function init_plyr_on_video() {
    // https://github.com/sampotts/plyr
    var players = Plyr.setup('#main .js-plyr', {
      vimeo: {
        controls: false,
      },
      fullscreen: { enabled: true, fallback: true, iosNative: true, container: null },
      controls: ['play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen', 'play-large']
    });

    // if(players && players.length) {
    //   players.forEach(player => {
    //     player.on('ready', (event) => {
    //       setTimeout(() => {
    //         $(event.detail.plyr.elements.container).find('.plyr__control.plyr__control--overlaid').append('<span class="plyr__controlTitle">'+event.detail.plyr.config.title+'</span>');
    //       }, 500);
    //     });
    //   });
    // }
  }

  d.addEventListener('lazybeforeunveil', function (e) {
    var $el = $(e.target);
    if (!$el.is('iframe')) return;
    $el.attr('src', $el.attr('data-src'));
    if ($el.closest('.media.is-type-video').length) {
      $el.wrap('<div class="js-plyr"></div>');
    }
    reinit_videos();
    e.preventDefault();
  });

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Select redirect
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  $main.find('.js-select-redirect').on('change', function () {
    var url = $(this).val();
    if (url) {
      window.location = url;
    }
    return false;
  });

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Keys event
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  $html.on("keydown", function (event) {
    if (event.which == 27) {
      // menu_mobile_close();
      // closeSubMenu(true);
      // modale_close();
    }
  });

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //On resize
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  $window.on('resize', function (event) {
    update_dimensions();
    $window.trigger('scroll');
  });

  // Avec debounce
  var onResizeDebounce = debounce(function () {
    setCssVarVH();
    resizeselect();
    set_is_acc_mobile();
    // grid_init();
  }, 300);
  $window.on('resize', onResizeDebounce);

  $window.trigger('resize');

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //On scroll
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  var ticking = false;
  $window.on('scroll', function (event) {
    update_scroll();
    requestTick();
  });

  function requestTick() {
    if (!ticking) {
      ticking = true;
      w.requestAnimationFrame(trigger_scroll);
    }
  }

  function trigger_scroll() {
    ticking = false;
    auto_hide_header();
    update_header();
    // sticky_update_all();
    // page_nav_update();
    // $window.trigger('resize.adp'); //datepicker
  }

  // Slider page
  $('.slider_content.swiper-container').each(function () {
    var $container = $(this),
      $navButtons = $container.prev('.swiper-buttons'),
      $navButtonPrev = $navButtons.find('.swiper-button-prev'),
      $navButtonNext = $navButtons.find('.swiper-button-next'),
      $pagination = $container.find('.swiper-pagination');
    new Swiper(this, {
      spaceBetween: 24,
      slidesPerView: 'auto',
      navigation: {
        prevEl: $navButtonPrev.get(0),
        nextEl: $navButtonNext.get(0),
      },
      pagination: {
        el: $pagination.get(0),
        clickable: true
      },
    });
  });

  // Slider rebonds

  function rebonds_display($cont) {
    $cont = $cont && $cont.length ? $cont : $main;
    var $rebonds = $cont.find('.rebond_list');
    var $slider = $rebonds.find('.swiper-wrapper');
    if (windowW <= 768) {
      $slider.removeClass("grid3");
    }
  }
  rebonds_display();

  $(window).on('resize', rebonds_display);

  $('.rebond_list.swiper-container').each(function () {
    var $container = $(this),
      $navButtons = $container.prev('.swiper-buttons'),
      $navButtonPrev = $navButtons.find('.swiper-button-prev'),
      $navButtonNext = $navButtons.find('.swiper-button-next');
    new Swiper(this, {
      enabled: false,
      navigation: {
        prevEl: $navButtonPrev.get(0),
        nextEl: $navButtonNext.get(0),
      },
      breakpoints: {
        // Quand la largeur est >= 320px
        320: {
          enabled: true,
          slidesPerView: 1.25,
          spaceBetween: 18,
        },
        // Quand la largeur est >= 768px
        768: {
          enabled: false,
          slidesPerView: 'auto',
        }
      },
    });
  })

  // Slider home
  const $sliderHome = $('.slider_home.swiper-container'),
    sliderHome = $sliderHome.get(0),
    $swiperPagination = $sliderHome.find('.swiper-pagination'),
    swiperPagination = $swiperPagination.get(0),
    $swiperPaginationBullets = $swiperPagination.find('.swiper-pagination-bullet');

  var swiper_home_pagination;
  var swiper_home = new Swiper('.slider_home.swiper-container', {
    slidesPerView: 1,
    spaceBetween: 0,
    slidesPerGroup: 1,
    // direction: 'horizontal',
    effect: 'fade',
    pagination: {
      el: '.slider_home.swiper-container .swiper-pagination',
      type: 'custom',
      clickable: true
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    // breakpoints: {
    //     850: {
    //         direction: 'vertical',
    //     },
    // },
    // loop: true,
    watchSlidesProgress: true,
    on: {
      slideChange: function (swiper) {
        $swiperPagination.removeClass('start-timer');
        $swiperPaginationBullets.filter('[data-slide-index=' + swiper.activeIndex + ']').trigger('click');
        $swiperPagination.addClass('start-timer');
        if (swiper_home_pagination) {
          swiper_home_pagination.slideTo(swiper.activeIndex);
        }
      }
    },
  });

  function swiper_home_pagination_init() {
    if (window.innerWidth <= 850) {
      $main.find('.swiper-pagination-bullets.swiper-wrapper').removeClass('swiper-wrapper');
      swiper_home_pagination = new Swiper('.slider_home.swiper-container .swiper-pagination', {
        slidesPerView: 1,
        spaceBetween: 0,
        slideToClickedSlide: true,
        initialSlide: swiper_home.activeIndex,
        on: {
          slideChange: function (swiper) {
            swiper_home.slideTo(swiper.activeIndex);
          }
        }
      });
    } else if (swiper_home_pagination) {
      swiper_home_pagination.destroy();
    }
  }
  swiper_home_pagination_init();
  $(window).on('resize', swiper_home_pagination_init);

  $swiperPagination.addClass('start-timer');
  function slider_home_padding() {
    if (sliderHome) {
      sliderHome.style.setProperty('--slider-padding-bottom', (swiperPagination.offsetHeight + window.innerWidth * .1) + 'px');
    }
  }
  slider_home_padding();
  // La hauteur de la pagination change une fois les polices chargées
  if (document.fonts) {
    document.fonts.ready.then(slider_home_padding);
  }
  $(window).on('load', slider_home_padding);
  $swiperPaginationBullets.each(function () {
    const $swiperPaginationBullet = $(this);
    const swiperPaginationBullet = $swiperPaginationBullet.get(0);
    $swiperPaginationBullet.on('click', function () {
      $swiperPaginationBullets.removeClass('swiper-pagination-bullet-active');
      $swiperPaginationBullets.removeAttr('aria-current');
      $swiperPaginationBullet.addClass('swiper-pagination-bullet-active');
      $swiperPaginationBullet.attr('aria-current', true);
      swiperPagination.style.setProperty('--slider-nav-left', swiperPaginationBullet.offsetLeft + 'px');
      swiperPagination.style.setProperty('--slider-nav-width', swiperPaginationBullet.offsetWidth + 'px');
    });
    $swiperPaginationBullet.on('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ' || event.keyCode === 13 || event.keyCode === 32) {
        $swiperPaginationBullet.trigger('click');
        swiper_home.slideTo($swiperPaginationBullet.attr('data-slide-index'));
        if (swiper_home_pagination) {
          swiper_home_pagination.slideTo($swiperPaginationBullet.attr('data-slide-index'));
        }
      }
    });
    if ($swiperPaginationBullet.hasClass('swiper-pagination-bullet-active')) {
      swiperPagination.style.setProperty('--slider-nav-left', swiperPaginationBullet.offsetLeft + 'px');
      swiperPagination.style.setProperty('--slider-nav-width', swiperPaginationBullet.offsetWidth + 'px');
    }
  });
  $(window).on('resize', function () {
    slider_home_padding();
    const swiperPaginationBullet = $swiperPaginationBullets.filter('.swiper-pagination-bullet-active').get(0);
    if (!swiperPaginationBullet) return;
    swiperPagination.style.setProperty('--slider-nav-left', swiperPaginationBullet.offsetLeft + 'px');
    swiperPagination.style.setProperty('--slider-nav-width', swiperPaginationBullet.offsetWidth + 'px');
  });

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Panel settings
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  setEvents('.js-panel-toggle[aria-controls]', toggle_panel);
  setEvents('.js-panel-close', function (event, btn) {
    toggle_panel(event, $('.js-panel-toggle[aria-controls="' + btn.closest('[aria-modal="true"], [role="dialog"]').id + '"]'));
  });

  function toggle_panel(event, btn) {
    if (event) {
      event.preventDefault();
    }
    menu_close();
    if (btn.matches('[aria-expanded="true"]')) {
      close_panel(btn.getAttribute('aria-controls'));
    } else {
      open_panel(btn.getAttribute('aria-controls'));
    }
  }

  function close_panel(panelID) {

    var btn = panelID ? $('.js-panel-toggle[aria-controls="' + panelID + '"][aria-expanded="true"]') : $('.js-panel-toggle[aria-controls][aria-expanded="true"]');
    var panel = btn ? $('#' + panelID) : false;
    if (btn) {
      btn.attr('aria-expanded', 'false');
    }
    if (panel) {
      panel.attr('aria-hidden', 'true');
    }
  }

  function open_panel(panelID) {
    var panel = $('#' + panelID);
    var btn = $('.js-panel-toggle[aria-controls="' + panelID + '"]');

    if (!btn || !panel) return;
    btn.attr('aria-expanded', 'true');
    panel.attr('aria-hidden', 'false');
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Settings
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  var initialFontSize = parseInt(w.getComputedStyle(body, null).getPropertyValue("font-size"));
  var fontSize = initialFontSize;

  setEvents('.js-settings-size-dec', decrease_font_size);
  setEvents('.js-settings-size-inc', increase_font_size);

  function decrease_font_size(event) {
    if (event) {
      event.preventDefault();
    }
    fontSize -= 1;
    set_font_size();
  }

  function increase_font_size(event) {
    if (event) {
      event.preventDefault();
    }
    fontSize += 1;
    set_font_size();
  }

  function set_font_size() {
    html.style.setProperty('--text-font-size', fontSize + 'px');
    localStorage.setItem("font-size", fontSize + 'px');
    check_font_size();
  }

  function check_font_size() {
    if (fontSize >= 24) {
      $('.js-settings-size-inc').attr('disabled', 'disabled');
    } else {
      $('.js-settings-size-inc').removeAttr('disabled');
    }
    if (fontSize <= 12) {
      $('.js-settings-size-dec').attr('disabled', 'disabled');
    } else {
      $('.js-settings-size-dec').removeAttr('disabled');
    }
    window.dispatchEvent(new Event('resize'));
  }

  var $colorThemeRadios = $header.find('input[name="color-theme-radios"]');

  $colorThemeRadios.on('change', function () {
    if (this.value === 'dark') {
      $html.attr('data-theme-color', 'dark');
      localStorage.setItem("theme-color", 'dark');
    } else {
      $html.removeAttr('data-theme-color');
      localStorage.setItem("theme-color", 'light');
    }
  });

  setEvents('.js-settings-reset', reset_settings);
  function reset_settings(event) {
    if (event) {
      event.preventDefault();
    }
    html.style.removeProperty('--text-font-size');
    fontSize = initialFontSize;
    localStorage.removeItem("font-size");
    check_font_size();
    var autoThemeDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    if (autoThemeDark) {
      $html.attr('data-theme-color', 'dark');
      $colorThemeRadios.filter('[value="dark"]').prop('checked', true);
    } else {
      $html.removeAttr('data-theme-color');
      $colorThemeRadios.filter('[value="light"]').prop('checked', true);
    }
    localStorage.removeItem("theme-color");
  }

  function set_saved_settings() {
    var savedFontSize = localStorage.getItem("font-size");
    var savedThemeColor = localStorage.getItem("theme-color");
    if ((!savedThemeColor || savedThemeColor == 'auto') && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      savedThemeColor = 'dark';
    }
    if (savedFontSize) {
      fontSize = parseInt(savedFontSize);
      set_font_size();
    }
    if (savedThemeColor) {
      if (savedThemeColor == 'dark') {
        $html.attr('data-theme-color', 'dark');
        $colorThemeRadios.filter('[value="dark"]').prop('checked', true);
      } else {
        $html.removeAttr('data-theme-color');
        $colorThemeRadios.filter('[value="light"]').prop('checked', true);
      }
    }
  }
  set_saved_settings();

})(jQuery);
